
























































































import { sensitiveWordDelete, sensitiveWordQuery, sensitiveAllowItem } from '@/service/data'
import { getIllegalTypes } from '@/service/settings'
import zhCN from 'ant-design-vue/lib/locale-provider/zh_CN'
import { Component, Vue, Prop, Watch } from 'vue-property-decorator'

@Component
export default class BlockList extends Vue {
  @Prop() public activeKey!: string
  // 国际化配置
  public localeZHCN = zhCN
  // search-data
  public searchParams = {
    word_name: '',
    sensitive_type: 0,
    begin_time: '',
    end_time: '',
    page_index: 1,
    is_white: true // 是否为白名单
  }
  public sensitiveTypes = getIllegalTypes([0, '不限'])
  // operation-data
  // pagination-data
  public paginationData = {
    total: 0,
    current: 1,
    pageSize: 30,
    showTotal(total) {
      return `共 ${total} 条`
    },
    onChange: this.pageChange
  }
  // list-data
  public columnTitles = [
    {
      title: 'Id',
      dataIndex: 'id',
      width: '15%',
      key: 'id'
    },
    {
      title: '白名单词',
      dataIndex: 'name',
      key: 'name'
    },
    {
      title: '添加人(审核员)',
      dataIndex: 'username',
      key: 'username'
    },
    {
      title: '入库时间',
      dataIndex: 'in_white_list',
      width: '20%',
      key: 'in_white_list'
    }
  ]
  public selectedRowKeys = []
  public sensitiveWords = new Array<object>()
  public visible = false
  public loading = false
  public spinning = false
  public word = ''
  public error = ''
  /*
   * created
   */
  public created() {
    this.searchSensitiveWord(1)
  }
  /*
   * methods
   */
  // 日期选择
  public dateChoose(date, dateStrings) {
    this.searchParams.begin_time = dateStrings[0]
    this.searchParams.end_time = dateStrings[1]
  }
  // 敏感词查询
  public async searchSensitiveWord(page) {
    this.spinning = true
    this.searchParams.page_index = page
    let response = await sensitiveWordQuery(this.searchParams)
    this.spinning = false
    if (response.success) {
      this.sensitiveWords = response.data
      this.paginationData.pageSize = response.page_size
      this.paginationData.total = response.total
      this.paginationData.current = response.page_index
    }
  }
  // 页码变化
  public pageChange(page) {
    setTimeout(() => {
      this.selectedRowKeys = []
    }, 1000)
    this.searchSensitiveWord(page)
  }
  // 敏感词选择
  public onSelect(selectedRowKeys) {
    this.selectedRowKeys = selectedRowKeys
  }
  // 删除敏感词
  public async _deleteSensitiveWord() {
    let params = { word_ids: JSON.stringify(this.selectedRowKeys) }
    let response = await sensitiveWordDelete(params)
    if (response.success) {
      this.$message.success('删除成功')
      this.searchSensitiveWord(this.paginationData.current)
      this.selectedRowKeys = []
    }
  }
  public deleteSensitiveWord() {
    let that = this
    if (this.selectedRowKeys.length === 0) {
      return
    }
    this.$confirm({
      title: '删除',
      content: '是否从白名单中删除？',
      okText: '确认',
      cancelText: '取消',
      onOk() {
        return that._deleteSensitiveWord()
      }
    })
  }
  public async addBlockItem() {
    let data = await sensitiveAllowItem({ word_name: this.word })
    this.loading = false
    if (data.success) {
      this.visible = false
      this.$message.success('已成功添加至白名单～')
      // 添加成功之后刷新列表
      this.searchSensitiveWord(1)
    } else {
      this.error = data.error
    }
  }
  public handleOk() {
    this.loading = true
    this.addBlockItem()
  }
  public handleCancel() {
    this.visible = false
  }
  public onWordNameChange() {
    if (this.searchParams.word_name === '') {
      this.searchSensitiveWord(1)
    }
  }
  // 当modal关闭的时候同时，清除提示文案以及输入框内容
  @Watch('visible')
  public onVisibleChange(val) {
    if (!val) {
      this.error = ''
      this.word = ''
    }
  }
  @Watch('activeKey')
  public onActiveKeyChange(val) {
    if (val === '2') {
      this.searchSensitiveWord(1)
    }
  }
}
